module.exports = __webpack_public_path__ + "img/181.cb36549c.jpg";